"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Copyright = exports.Social = exports.Link = exports.Links = exports.Logo = exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _widths = require("../../../styles/widths");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

var Container = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  overflow: auto\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0 ", "px;\n  background: ", ";\n  color: ", ";\n  border-color: ", ";\n  & a {\n    color: ", ";\n  }  \n  & path {\n    fill: ", ";\n  }\n  &>div {\n    max-width: 1112px;\n  }\n"])), _widths.widths.base * 2, function (_ref) {
  var background = _ref.background;
  return background;
}, function (_ref2) {
  var color = _ref2.color;
  return color;
}, function (_ref3) {
  var color = _ref3.color;
  return color;
}, function (_ref4) {
  var color = _ref4.color;
  return color;
}, function (_ref5) {
  var color = _ref5.color;
  return color;
});

exports.Container = Container;
Container.displayName = 'Container';

var Logo = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-top: ", "px;\n"])), _widths.widths.base * 4);

exports.Logo = Logo;
Logo.displayName = 'Logo';

var Links = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  margin-top: ", "px;\n  ", " {\n    &>a:not(:first-child) {\n      margin-left: 80px;\n    }\n  }\n  ", " {\n    flex-direction: column;\n    align-items: center;\n    &>a:not(:first-child) {\n      margin-top: ", "px;\n    }    \n  }\n"])), _widths.widths.base * 6, _widths.mediaQueries.desktop, _widths.mediaQueries.notDesktop, _widths.widths.base * 3);

exports.Links = Links;
Links.displayName = 'Links';

var Link = _styledComponents["default"].a(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  text-decoration: none;\n  font-size: 12px;\n  line-height: ", "px;\n"])), _widths.widths.base * 2);

exports.Link = Link;
Link.displayName = 'Link';

var Social = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  margin-top: ", "px;\n  &>div:not(:first-child) {\n    margin-left: ", "px;\n  }\n  & svg {\n    cursor: pointer;\n  }\n"])), _widths.widths.base * 6, _widths.widths.base * 4);

exports.Social = Social;
Social.displayName = 'Social';

var Copyright = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  width: 100%;\n  border-top: 1px solid;\n  text-align: center;\n  font-size: 12px;\n  line-height: 12px;  \n  margin: ", "px 0 ", "px 0;\n  padding-top: ", "px;\n"])), _widths.widths.base * 3, _widths.widths.base * 4, _widths.widths.base * 3);

exports.Copyright = Copyright;
Copyright.displayName = 'Copyright';